var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-loader"},[_c('div',[(_vm.message)?_c('p',{staticClass:"wi-100 text-center white--text"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('v-progress-linear',{attrs:{"color":"secondary","indeterminate":"","rounded":"","height":"6"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }